import React from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@material-ui/core';

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100, 200];

const DataTablePagination = (props) => (
  <TablePagination
    count={props.page.totalElements}
    rowsPerPage={props.page.size}
    page={props.page.number}
    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
    onChangePage={(event, number) => props.onChangePage(number)}
    onChangeRowsPerPage={(event) =>
      props.onChangeRowsPerPage(event.target.value)
    }
    rowsPerPageOptions={props.rowsPerPageOptions}
  />
);

DataTablePagination.propTypes = {
  page: PropTypes.object.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number)
};

DataTablePagination.defaultProps = {
  rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS
};

export default DataTablePagination;
